import { render } from "./customizeItem.vue?vue&type=template&id=1fdb5522&scoped=true"
import script from "./customizeItem.vue?vue&type=script&lang=js"
export * from "./customizeItem.vue?vue&type=script&lang=js"

import "./customizeItem.vue?vue&type=style&index=0&id=1fdb5522&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdb5522"]])

export default __exports__